/**
 * React Query Provider
 *
 * Wraps the app with QueryClientProvider and DevTools.
 * Following Vercel/Linear pattern - single provider at root level.
 */

import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { queryClient } from '../lib/react-query'
import { config } from '../config'

interface QueryProviderProps {
  children: React.ReactNode
}

/**
 * QueryProvider component
 *
 * Provides React Query context to the entire application.
 * Includes DevTools in development mode for debugging.
 *
 * @example
 * ```tsx
 * <QueryProvider>
 *   <App />
 * </QueryProvider>
 * ```
 */
export function QueryProvider({ children }: QueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* DevTools only in development */}
      {config.env.isDevelopment && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  )
}
